import useCohort from "cohorts/hooks/useCohort";
import { useFetcher } from "~/hooks/useFetcher";

const useTotalParticipantsCount = () => {
  const { data: cohort } = useCohort();
  return useFetcher<{ participant_count: number }>(
    cohort?.dataset_id ? `/api/cohort-explorer/counts?dataset_id=${cohort.dataset_id}` : null
  );
};

export default useTotalParticipantsCount;
